import { Component, OnInit } from '@angular/core';
import {
  IDialog,
  IDialogOptions
} from '../../../../shared/secured-shared/dialog/dialog.service';

@Component({
    selector: 'app-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.scss'],
    standalone: false
})
export class DeleteConfirmationDialogComponent
  implements
    OnInit,
    IDialog<
      {
        message: string;
      },
      boolean
    >
{
  public data: {
    message: string;
  };

  public close: (value: boolean) => void;

  public dialogOptions: IDialogOptions;

  public ngOnInit(): void {
    this.dialogOptions.cancelButton.show = true;
    this.dialogOptions.deleteButton.show = true;
    this.dialogOptions.saveButton.show = false;
  }

  public onCancel(): void {
    this.close(false);
  }

  public onDelete(): void {
    this.close(true);
  }

  public onConfirm(): void {}
}
